import 'reflect-metadata';
import {jsonObject, jsonMember} from 'typedjson';

@jsonObject
export class SoftwareDetails {

  @jsonMember({name: 'id'})
  public Id!: string;

  @jsonMember({name: 'label'})
  public Label!: string;

  @jsonMember({name: 'binName'})
  public BinName!: string;

  @jsonMember({name: 'binPath'})
  public BinPath!: string;

  @jsonMember({name: 'version'})
  public Version!: string;
}
